// extracted by mini-css-extract-plugin
export default {"readInputClass":"index_readInputClass__fq-cJ","answerGroup":"index_answerGroup__eK7CE"};